// 위챗 오픈플랫폼 API 래퍼 (SPEC-CHINA-WECHAT-OPEN-PLATFORM-001 §6)
//  - 운영자 API: chinaInapi(JWT 자동 부착, XINLAIAN 전용)
//  - 공개 API: 인증 헤더·401 재발급 인터셉터가 없는 별도 axios (초대 토큰이 대신 방어한다)
import axios from 'axios';
import i18n from '@/i18n';
import { chinaInapi } from './chinaInapi';

const BASE = '/wechat-open';

export const wechatOpenApi = {
    getStatus: () => chinaInapi.get(`${BASE}/status`),
    // 공중계정 1행 = 1줄(stage/nextAction 포함, owner·relay 공통). 목록의 유일한 출처.
    listAccounts: () => chinaInapi.get(`${BASE}/accounts`),
    syncAuthorizers: () => chinaInapi.post(`${BASE}/authorizers/sync`),
    restartPushTicket: () => chinaInapi.post(`${BASE}/ticket/restart-push`),
    createInvitation: (body) => chinaInapi.post(`${BASE}/invitations`, body),
    listInvitations: (gzhName) => chinaInapi.get(`${BASE}/invitations`, gzhName ? { params: { gzhName } } : undefined),
    revokeInvitation: (invitationId) => chinaInapi.post(`${BASE}/invitations/${encodeURIComponent(invitationId)}/revoke`),
    setAuthMode: (gzhName, authMode) => chinaInapi.put(`${BASE}/accounts/${encodeURIComponent(gzhName)}/auth-mode`, { authMode }),
};

// 공개 페이지용: Authorization 없음, 401 재발급 없음.
const publicHttp = axios.create({
    baseURL: process.env.VUE_APP_CHINA_INAPI_URL,
    timeout: 20000,
});
publicHttp.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = i18n.global.locale.value === 'ko' ? 'ko' : 'zh';
    return config;
});

export const wechatOpenPublicApi = {
    getInvitation: (token) => publicHttp.get(`${BASE}/public/invitations/${encodeURIComponent(token)}`),
    createAuthorizeLink: (token, client) => publicHttp.post(`${BASE}/public/invitations/${encodeURIComponent(token)}/authorize-link`, { client }),
    submitCallback: ({ n, authCode }) => publicHttp.post(`${BASE}/public/authorize-callback`, { n, authCode }),
};
